<template>
  <h1 class="title " style="text-align: left; font-size: calc(1rem + 2vw); color: white; font-weight: bold ">Ростер для 23 перепёлок</h1>
  <div class="row row-cols-1 gy-4 gx-3 px-3 ps-0 pe-0 " >
    <div class="col-md-6 col-sm-1 middle-col ">
      <div id="carouselExampleAutoplaying" class="carousel slide " data-bs-ride="carousel" style=" height: auto">
        <div class="carousel-inner w-100" >
          <div class="carousel-item active w-100">
            <img src="/assets/roaster-for-23-quails-box.jpg" class="d-block w-100" alt="...">
          </div>
          <div class="carousel-item">
            <img src="/assets/Ростер_для_23_перепёлок_375х335х115мм.png" class="d-block w-100 bg-white" alt="...">
          </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Предыдущий</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Следующий</span>
        </button>
      </div>
    </div>
    <div class="col-md-4 col-sm-1 col-lg-5 ">
      <div class="layout__content text-start text-white w-text-screen">
        <p>Этот большой ростер позволяет комфортно запечь или закоптить до 23 перепёлок в духовке или в больших грилях. Идеальная золотистая корочка без изъянов и нежное, сочное мясо внутри теперь доступно любому! Также на этом ростере великолепно получаются болгарские перцы!</p>
        <p>Ростер предназначен для приготовления маленькой птицы и перцев в режиме непрямого жара, конвекции, горячего и холодного копчения. Подходит для использования в грилях, духовых шкафах и коптильнях.</p>
        <p>Материал: Пищевая нержавеющая сталь.</p>
      </div>
      <div>
        <p class="text-start " style="color: #ED5500FF; font-size: calc(1rem + 0.7vw); font-weight: bold ">9000 ₽</p>
        <div class="catalog-button-buy-container">
          <a type="button" class="btn btn-lg catalog_buy_button px-2 py-2" target="_blank"
             href="https://market.yandex.ru/product--roster-dlia-23-perepelok/1866148423?hid=13776495&show-uid=17223457227352188016416004&from=search&rs=eJwNxMERgDAIBMDRl93AEQLU4MuxhATovwTdx8r5HPdVG92u_ApcZOj8hxoFgjWzY65YVja6uSW3G4qNmUD4AAkOEA0%2C&businessId=5039871&sku=102029015194&cpa=1&do-waremd5=UjM0p4FfQx8JvEhBUum7IA&cpc=ZGSBvmiT3FxzRiR9Yvx1NtXgiJnEo88AFDvXEuuhNu6UkBer0awVw2sue8f7nRs3UD7VBNAX4A-HgA9qqSllYofJf2Hy2FNdGeE_T6cpL57xNnR6yG1TefbomJqGKftXFDWVzm5H2kVqg_Y06HfO8Kur0qdZi8mJCfRxbsFSQSBqxAA7r25c8yi6aQYCVdCI7zfix4OyiLyHJY5TE5q8xjq_CsKGeWyDbkjARC6JHshEhstwD33M6mUBynoLf3yFYPSds_dQJOxgFnFFWXPC9pGYE6-qa4bT&cc=CjIxNzIyMzQ1NzIyMTQ2LzgxODA0ZGRmODViOGI2ZTYzZmYwZjJkYzc2MWUwNjAwLzEvMRDoH4B95u0G&uniqueId=5039871"
             style="font-size: calc(1rem + 0.5vw); width: 100%">Купить</a>
        </div>
      </div>
    </div>
  </div>
  <div class="tabs mt-2">
    <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab"
        :class="{ active: activeTab === index }"
        @click="setActiveTab(index)"
    >
      {{ tab.title }}
    </div>
  </div>
  <div
      v-for="(tab, index) in tabs"
      :key="index"
      class="content mt-2"
      :class="{ active: activeTab === index }"
  >
    <component :is="tab.component" />
  </div>

</template>

<script>
import CharacteristicsComponent from '/src/components/ProductCharacteristicsRoster23Screen.vue';
import RecommendationsForCareScreen from "@/components/RecommendationsForCareScreen.vue";
export default {
  data() {
    return {
      activeTab: 0,
      tabs: [
        { title: "Характеристики", component: CharacteristicsComponent },
        { title: "Рекомендации по уходу", component: RecommendationsForCareScreen },
      ],
    };
  },
  methods: {
    setActiveTab(index) {
      this.activeTab = index;
    },
  },

};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@media (min-width: 950px) and (max-width: 1799px) {
  .middle-col{
    flex:0 0 auto;
    width:41.66666667%!important;
  }
}
@media (min-width: 1800px) {
  .middle-col{
    flex:0 0 auto;
    width:33.33333333%!important;
  }
}
.brand {
  text-align: left; /* Выравнивание по левому краю */
}

.dots {
  flex-grow: 1;
  margin: 0 5px; /* Отступ для точек */
}

.addgrill {
  text-align: right; /* Выравнивание по правому краю */
}

p {
  display: flex; /* Включение flex-контейнера */
  justify-content: space-between; /* Равномерное распределение пространства */
}
.tabs {
  display: flex;
}

.tab {
  padding: 10px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.3s ease; /* Add transition for smooth animation */
  justify-content: center;
  font-size: calc(1rem + 0.3vw); /* Increase font size for active tab */
  color: #747474ff;
  margin: 0 5px; /* Add margin for spacing between tabs */
}

.tab.active {
  color: white;
  border-bottom: 2px solid #ED5500FF; /* Highlight active tab color */
  font-size: calc(1rem + 0.3vw);  /* Increase font size for active tab */
}

.content {
  display: none;
  padding: 0.25rem;
}

.content.active {
  display: block;
}

@media (max-width: 600px) {
  .w-text-screen{
    font-size: calc(1rem + 0.3vw);
  }
}
@media (max-width: 1100px) and (min-width: 601px) {
  .w-text-screen{
    font-size: calc(1rem + 0.3vw);
  }
}
@media (max-width: 1549px) and (min-width: 1101px) {
  .w-text-screen{
    font-size: calc(0.8rem + 0.3vw);
  }
}
@media (min-width: 1550px) {
  .w-text-screen{
    font-size: calc(1rem + 0.3vw);
  }
}
.catalog_buy_button {
  height: 20%;
  border-radius: 0 !important;
  -webkit-transition: all .2s ease;
  transition: all .2s ease;
  background-color: #ED5500FF;
  color: #ffffff;
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  max-width: 100%;
  outline: none;
  text-align: center;
  text-decoration: none;
  vertical-align: bottom;
}
.catalog_buy_button:hover {
  background-color: #ED5500FF;
  color: #ffffff;
  box-shadow: 0 8px 24px 0 rgba(242, 242, 242, 0.2);
}

</style>
